import React, { useContext } from 'react';
import { Row, Col, Layout } from 'antd';
import MixedTimeline from '../Timeline/MixedTimeline';
import { ThemeContext } from '../Context/ThemeContext';
import { ProfileContext } from '../Context/ProfileContext';
import LandingPage from '../Static/LandingPage/LandingPage';
import TimeHeader from '../Header/TimeHeader';

const { Content } = Layout;

export default function Feed() {
  const { theme } = useContext(ThemeContext);
  const { loggedin, authChecked } = useContext(ProfileContext);

  if (!authChecked) return null;

  return (
    <div>
      {loggedin ? (
        <div>
          <TimeHeader />
          <Content
            style={{
              padding: '80px 1.5rem 1.5rem 1.5rem',
              background: theme.content.bg,
            }}
          >
            <Row>
              <Col sm={0} md={4} lg={6} />
              <Col sm={24} md={16} lg={12}>
                <MixedTimeline />
              </Col>
              <Col sm={0} md={4} lg={6} />
            </Row>
          </Content>
        </div>
      ) : (
        <LandingPage />
      )}
    </div>
  );
}
